document.addEventListener('DOMContentLoaded', function() {
  // console.log('running global 360');
let skipSwipeUpdate = false;
  const tryOnBlock = document.querySelector('.image_button_button.dekstech-try');
  const submitButton = document.querySelector('.product-form__submit');
  const maintenanceLabel = document.querySelector('.checkbox-container');
 // console.log('🔍 Found tryOnBlock:', tryOnBlock);
//  console.log('🔍 Found submitButton:', submitButton);

  if (tryOnBlock && submitButton) {
    // Move the try-on block below the submit button
    submitButton.insertAdjacentElement('beforebegin', tryOnBlock);

   // console.log('✅ Try-On block moved below submit button');
  } else {
  //  console.warn('❌ Could not find one or both elements.');
  }
if (maintenanceLabel && submitButton) {
  const clone = maintenanceLabel.cloneNode(true); // Deep clone
  clone.classList.add('mobile-only'); // Add class to clone
  clone.classList.remove('desktop-only');
  submitButton.insertAdjacentElement('afterend', clone); // Insert after ATC
}
            const checkboxes = document.querySelectorAll('.maintenance-check');
          const checkbox = Array.from(checkboxes).some(cb => cb.checked);

  const form = document.querySelector(".product-form form");
  const quantityInput = document.querySelector(".custom-quantity__input");
  
  const slides = document.querySelectorAll('.cycle-through');
  const thumbnails = document.querySelectorAll('.thumbnail'); // Select all thumbnails

const cartierSection = document.querySelector('.latest_product_section.cartier-custom');
const prevBtns = document.querySelector(".new-previous-button");
const nextBtns = document.querySelector(".new-next-button");

  const pillInputs = document.querySelectorAll('.product-form__input--pill'); // Select all pills
  const pauseButton = document.getElementById('pause');
  const playButton = document.getElementById('play');
  const rotateButton = document.getElementById('rotate');
  
  let isDragging = false; // Track if the user is dragging
  let startX = 0; // Track the starting X position
  let endX;
  let currentX = 0;
  let currentSlide = Array.from(slides).findIndex(slide => slide.classList.contains('is-active'));
  currentSlide = currentSlide !== -1 ? currentSlide : 0; // Default to the first slide
  const totalSlides = slides.length;
  let lastSlideChangeTime = 0; // To control the speed of the slide transition
  let intervalId = null;
  let isPaused = false; // To track paused state

// Prevents vertical scrolling when dragging
function disableScroll() {
    document.body.style.overflow = 'hidden';
}

// Re-enable scrolling when drag ends
function enableScroll() {
    document.body.style.overflow = '';
}

let throttleTimeout = null;

function onTouchMove(e) {

  // Extract movement
  const currentTouchX = e.touches[0].clientX;
  const currentTouchY = e.touches[0].clientY;
  const moveDeltaX = Math.abs(currentTouchX - startTouchX);
  const moveDeltaY = Math.abs(currentTouchY - startTouchY);
  const now = Date.now();
  const duration = now - touchStartTimestamp;

  const isHorizontal = moveDeltaX > moveDeltaY;
  const isQuickSwipe = moveDeltaX > 60 && duration < 200;
  const isDrag = moveDeltaX > 10;

  // If it's not horizontal, let the page scroll (do nothing)
  if (moveDeltaY > moveDeltaX) return;
  e.preventDefault(); // required when passive is false
  if (isQuickSwipe && isHorizontal && !isTouchDragging) {
    isTouchDragging = true;
    const isSwipeLeft = currentTouchX < startTouchX;

    const visibleThumbs = Array.from(document.querySelectorAll('.thumbnail-list__item'))
      .filter(el => el.offsetParent !== null);

    const currentIndex = visibleThumbs.findIndex(item =>
    item.querySelector('button')?.getAttribute('aria-current') === 'true'
    );

    if (currentIndex === -1 || visibleThumbs.length === 0) return;

    const newIndex = isSwipeLeft
      ? (currentIndex + 1) % visibleThumbs.length
      : (currentIndex - 1 + visibleThumbs.length) % visibleThumbs.length;

    const targetThumb = visibleThumbs[newIndex];
    const targetButton = targetThumb?.querySelector('button');
    if (targetButton) {
      setTimeout(() => targetButton.click(), 60);
    }

    skipSwipeUpdate = true;
    setTimeout(() => skipSwipeUpdate = false, 300);
    return;
  }

  // 🧠 Throttled drag update (limit heavy DOM updates)
  if (isDrag && isHorizontal && !skipSwipeUpdate) {
    if (!throttleTimeout) {
      throttleTimeout = setTimeout(() => {
        const deltaX = currentTouchX - lastTouchX;
if (Math.abs(deltaX) > 5) {
  updateSlideOnSwipe(deltaX);
}
        lastTouchX = currentTouchX;
        throttleTimeout = null;
      }, 50); // Adjust timing if needed
    }
  }
}

  function onTouchStart(event) {
  startTouchX = event.touches[0].clientX;
  startTouchY = event.touches[0].clientY;
  lastTouchX = startTouchX;
  touchStartTimestamp = Date.now();
  isTouchDragging = false;
  pauseCycle(); // Pause auto rotation when touching
}

  function onTouchEnd(event) {
  if (!isTouchDragging) return;
  let endTouchX = event.changedTouches[0].clientX;
  let totalTouchDeltaX = endTouchX - startTouchX;
  updateSlideOnSwipe(totalTouchDeltaX);
  isTouchDragging = false;
}


// End of mobile touch dragging and touching
  
// Function to update the active slide based on swipe direction (right = backward, left = forward)
function updateSlideOnSwipe(deltaX) {
  if (skipSwipeUpdate) {
 //   console.log("🚫 Skipping updateSlideOnSwipe due to quick swipe");
    return;
  }

  const threshold = 10;
  const currentTime = Date.now();
  let currentSlide = Array.from(slides).findIndex(slide => slide.classList.contains('is-active'));
const currentSlideEl = slides[currentSlide];
if (!currentSlideEl || !currentSlideEl.classList.contains('cycle-through')) {
  return;
}
  
  if (currentTime - lastSlideChangeTime < 50) return;
  lastSlideChangeTime = currentTime;

  if (deltaX < -threshold) {
    // ➡️ Swipe left = next slide
    let nextSlide = (currentSlide + 1) % slides.length;

    if (slides[nextSlide].classList.contains('stop-here')) {
      // console.log('trying to find new slide');
      // do nothing, let other script handle it
    } else {
      slides[currentSlide].classList.remove('is-active');
      slides[nextSlide].classList.add('is-active');
      currentSlide = nextSlide;
    }
  } else if (deltaX > threshold) {
    // ⬅️ Swipe right = previous slide
    let previousSlide = (currentSlide - 1 + slides.length) % slides.length;

    if (slides[currentSlide].classList.contains('stop-here')) {
      let previousStopHere = findSlideBeforeNextStopHere(currentSlide);
      slides[currentSlide].classList.remove('is-active');
      slides[previousStopHere].classList.add('is-active');
      currentSlide = previousStopHere;
    } else if (slides[previousSlide].classList.contains('stop-here')) {
      let slideBeforeNextStopHere = findSlideBeforeNextStopHere(currentSlide);
      slides[currentSlide].classList.remove('is-active');
      slides[slideBeforeNextStopHere].classList.add('is-active');
      currentSlide = slideBeforeNextStopHere;
    } else {
      slides[currentSlide].classList.remove('is-active');
      slides[previousSlide].classList.add('is-active');
      currentSlide = previousSlide;
    }
  }
}


  // Start the drag action
  function startDrag(event) {
    if (event.button !== 0) return; // Only start dragging on left-click (button 0)
    isDragging = true;
    startX = event.pageX || event.touches[0].pageX; // Capture the start position (mouse or touch)
    pauseCycle(); // Pause auto rotation when dragging starts
    slides[currentSlide].style.cursor = 'grabbing'; // Change cursor to grabbing
  }

  // Handle the drag movement
  function onDrag(event) {
  //  console.log("on drag");
    if (!isDragging) return;
    currentX = event.pageX || event.touches[0].pageX; // Track current position

  //  console.log("currentX: " + currentX + " startX: " + startX);
    const deltaX = currentX - startX; // Calculate how far the user has dragged
    updateSlideOnSwipe(deltaX * 10); // Update the slide based on direction
    
    // Save the current position as the new starting position after updating the slide
    startX = currentX;
  }

  // End the drag action when the user releases the left-click or touch ends
  function endDrag(event) {
    if (event.button !== 0 && event.type !== 'touchend') return; // Only stop dragging on left-click release or touchend
    if (!isDragging) return;
    isDragging = false;
  //  slides[currentSlide].style.cursor = 'pointer'; // Reset cursor to pointer
    // No auto-start, it stays paused after dragging
  }

  // Mouse events for dragging
  slides.forEach(slide => {
    slide.addEventListener('mousedown', startDrag);
    slide.addEventListener('mousemove', onDrag);
  });

  // Stop dragging when the user releases the left-click, even if outside the slider
  document.addEventListener('mouseup', endDrag); // Global event listener for mouseup to catch release outside the div
  slides.forEach(slide => {
    slide.addEventListener('mouseleave', onDrag); // Continue dragging even if the mouse leaves the div
  });


  // Helper function for automatic cycling
  function startCycle() {
//    console.log('start cycle');
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
    intervalId = setInterval(cycleSlides, 300); // Auto-rotate every 300ms
    isPaused = false;
    $('.top_button').css('visibility','visible');
    $('.top_button').removeAttr('style');
  }

  function pauseCycle() {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
    isPaused = true;
  }
// Helper function to find the slide before the next 'stop-here'
function findSlideBeforeNextStopHere(currentIndex) {
  let nextSlide = currentIndex;
  do {
    nextSlide = (nextSlide + 1) % totalSlides;
  } while (!slides[nextSlide].classList.contains('stop-here') && nextSlide !== currentIndex);

  // Now find the slide before this next 'stop-here'
  let slideBeforeStopHere = (nextSlide - 1 + totalSlides) % totalSlides;
  
  return slideBeforeStopHere;
}
// Helper function to find the previous 'stop-here' slide
function findPreviousStopHere(startIndex) {
  let prevSlide = startIndex;
  let iterations = 0; // Counter to prevent infinite loops

  // Loop through the slides backward
  do {
    prevSlide = (prevSlide - 1 + totalSlides) % totalSlides;
    iterations++;
  } while (
    !slides[prevSlide].classList.contains('stop-here') && 
    prevSlide !== startIndex && 
    iterations < totalSlides // Prevent infinite loops
  );

  // If no 'stop-here' slide is found, return the original startIndex
  if (iterations >= totalSlides || prevSlide === startIndex && !slides[prevSlide].classList.contains('stop-here')) {
    // console.warn('No previous "stop-here" found.');
    return startIndex; // Fallback to the original slide
  }

  return prevSlide;
}


  // Function to cycle slides forward and go back to the previous 'stop-here' if the next slide is 'stop-here'
function cycleSlides() {
  let currentSlide = Array.from(slides).findIndex(slide => slide.classList.contains('is-active'));
  let totalSlides = slides.length;
  if (currentSlide === -1) {
    // console.error("No active slide found. Cannot proceed with cycling.");
    return;
  }

  let nextSlide = (currentSlide + 1) % totalSlides;

  // Ensure nextSlide is within valid bounds
  if (!slides[nextSlide]) {
    // console.error("Invalid nextSlide index:", nextSlide);
    return;
  }

  // Check if both the current and the next slide have the 'stop-here' class
 // console.log('my current slide is ' + currentSlide + ' and my next slide is ' + nextSlide);
  if (
    slides[currentSlide]?.classList.contains('stop-here') &&
    slides[nextSlide]?.classList.contains('stop-here')
  ) {
 //   console.log("Both current and next slides are 'stop-here'. Stopping cycle.");
    $('.top_button').css('visibility', 'hidden');
    pauseCycle(); // Stop cycling
    return; // Exit the function to prevent further cycling
  } else {
    $('.top_button').css('visibility', 'visible');
    $('.top_button').removeAttr('style');
  }

  // Normal cycling behavior
  if (slides[nextSlide]?.classList.contains('stop-here')) {
 //   console.log(Encountered stop-here at index: ${nextSlide});
    const previousStopHereIndex = findPreviousStopHere(currentSlide);
  //  console.log(Returning to previous stop-here at index: ${previousStopHereIndex});

    if (slides[currentSlide]) slides[currentSlide].classList.remove('is-active');
    if (slides[previousStopHereIndex]) slides[previousStopHereIndex].classList.add('is-active');

  } else {
   // console.log('doing regular is active add and remove');
    if (slides[currentSlide]) slides[currentSlide].classList.remove('is-active');
    if (slides[nextSlide]) slides[nextSlide].classList.add('is-active');
  }
}


 var tags = $('product-info').data('tags');
 var currentactiveSlide = $('.slider__slide.is-active');
  if (tags.indexOf('no 360') === -1) {
  // startCycle(); // Start the cycle on page load
  }








$('body').on('click','#pause',function() {
  if (!isPaused) {
    pauseCycle(); // Pause if it's not already paused
  } else {
    startCycle(); // Resume if it's paused
  }
});

$('body').on('click','#play',function() {
  if (isPaused) {
    startCycle(); // Start cycling if it was paused
  }
});

$('body').on('click','#rotate',function() {
  if (isPaused) {
    startCycle(); // Start cycling if it was paused
  }
});


  $('body').on('click','.latest_qty .quantity__button',function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
      var name = $(this).attr('name');
   // console.log('my name is ' + name);
    if ($(this).hasClass('disabled')) {
      if (name === 'plus') {
        alert('You cannot add anymore since this item is low in stock!');
      }
      else {
        alert('You cannot order less than 1 item');
      }
    }
  });

  // Function to create hidden input fields dynamically
  function createHiddenInput(name, value) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    return input;
  }

  // Function to get the correct Maintenance Plan Variant ID
  function getMaintenanceVariantId() {
    let productPrice = parseInt(
      document.querySelector(".price-item--regular").textContent.replace(/[^0-9]/g, ""),
      10
    );

    if (productPrice <= 50000) {
      return "46447318892803";
    } else if (productPrice > 50000 && productPrice <= 75000) {
      return "46447318925571";
    } else if (productPrice > 75000 && productPrice <= 150000) {
      return "46447318958339";
    } else if (productPrice > 150000 && productPrice < 179900) {
      return "46447318991107";
    } else {
      return "46447319023875";
    }
  }

  // Function to add or update Maintenance Plan fields on the form
function addMaintenancePlanFields() {
  // console.log('Adding/updating maintenance plan fields…');

  const maintenanceVariantId = getMaintenanceVariantId();

  // Get currently selected main product variant
  const selectedVariantId = $('input[name="id"]').val(); // .val() is safer than .attr('value')
  // console.log('My selected variant is ' + selectedVariantId);

  // Find the matching variant title from .variant-list
  let variantProdCombo = '';
  $('.variant-list').each(function () {
    const variantId = $(this).attr('variant-id');
    // console.log('My variant list id is ' + variantId);

    if (selectedVariantId === variantId) {
      variantProdCombo = $(this).attr('variant-title');
    }
  });

  // console.log('I think my variant is ' + variantProdCombo);

  // --- ID FIELD ---
  let idField = document.getElementById('maintenance-plan-id');
  if (!idField) {
    idField = createHiddenInput('items[][id]', maintenanceVariantId);
    idField.id = 'maintenance-plan-id';
    form.appendChild(idField);
  } else {
    idField.value = maintenanceVariantId;
  }

  // --- QTY FIELD ---
  let qtyField = document.getElementById('maintenance-plan-qty');
  if (!qtyField) {
    qtyField = createHiddenInput('items[][quantity]', quantityInput.value);
    qtyField.id = 'maintenance-plan-qty';
    form.appendChild(qtyField);
  } else {
    qtyField.value = quantityInput.value;
  }

  // --- PROPERTIES FIELD ---
  let propField = document.getElementById('maintenance-plan-prop-title');
  if (!propField) {
    propField = createHiddenInput('items[][properties][Linked Product]', variantProdCombo);
    propField.id = 'maintenance-plan-prop-title';
    form.appendChild(propField);
  } else {
    propField.value = variantProdCombo;
  }
}

  // Function to remove Maintenance Plan fields from form
  function removeMaintenancePlanFields() {
    document.querySelectorAll("#maintenance-plan-id, #maintenance-plan-qty, #maintenance-plan-prop-title")
      .forEach(input => input.remove());
  }

  // Listen for checkbox toggle
checkboxes.forEach((checkboxey) => {
  checkboxey.addEventListener('change', function () {
    if (checkboxey.checked) {
      addMaintenancePlanFields(checkboxey);
    } else {
      removeMaintenancePlanFields(checkboxey);
    }
  });
});

function handleCheckbox(checkbox) {
  if (checkbox.checked) {
    addMaintenancePlanFields(checkbox);
  } else {
    removeMaintenancePlanFields(checkbox);
  }
}

// Run on page load
checkboxes.forEach((cb) => handleCheckbox(cb));

// Listen for changes
checkboxes.forEach((cb) => {
  cb.addEventListener('change', () => handleCheckbox(cb));
});

  // Ensure Maintenance Plan Quantity Updates with Main Product Quantity
  quantityInput.addEventListener("input", function () {
    const qtyField = document.getElementById("maintenance-plan-qty");
    if (checkbox.checked && qtyField) {
      qtyField.value = quantityInput.value;
    }
  });

/*
  // Update Maintenance Plan Variant ID on Variant Change
  document.addEventListener("variant:changed", function () {
    if (checkbox.checked) {
      addMaintenancePlanFields();
    }
  });
  */
  document.querySelector('.main_image_box')?.addEventListener('touchstart', onTouchStart, { passive: false });
document.querySelector('.main_image_box')?.addEventListener('touchmove', onTouchMove, { passive: false });
document.querySelector('.main_image_box')?.addEventListener('touchend', onTouchEnd, { passive: false });
   document.addEventListener('DOMContentLoaded', function () {
     

        // Optional: Listen for swipe events if you have custom slider/swiper
        let currentIndex = 0;

        function goToSlide(index) {
          // console.log('my slide is ' + index + 'and my thumbnail length is ' + thumbnails.length);
          if (index >= 0 && index < thumbnails.length) {
            thumbnails[index].click();
            currentIndex = index;
          }
        }

        // Add left/right navigation via swipe (basic example)
        let startX = 0;
      });
      
  const slider = document.querySelector('.latest_image_class');


function cycleImage(mediaId,variantId) {
  var tags = $('product-info').data('tags');
let newActiveSlide = document.querySelector(
  `media-gallery li[data-media-id="${mediaId}"].stop-here.cycle-through`
);

// Try 2: find by both mediaId and variantId
if (!newActiveSlide) {
  newActiveSlide = document.querySelector(
    `media-gallery li[data-media-id="${mediaId}"][data-variant-id="${variantId}"]`
  );
}

// Try 3: fallback to just mediaId
if (!newActiveSlide) {
  newActiveSlide = document.querySelector(
    `media-gallery li[data-media-id="${mediaId}"]`
  );
}
 

if (newActiveSlide) {
  newActiveSlide.classList.add('is-active');
  // console.log('✅ Found and activated slide:', newActiveSlide);
} else {
  // console.warn('❌ No slide found for mediaId:', mediaId, 'variantId:', variantId);
}
    if (newActiveSlide) {
      newActiveSlide.classList.add('is-active'); 

      const is360 = newActiveSlide.classList.contains('cycle-through');
      // console.log('my new active slide 360 is ' + is360);
      // console.log('my active slide is ' + mediaId );
      if (is360 && tags.indexOf('no 360') === -1) {
         setTimeout(function () {
          startCycle();
         }, 300);
      } else {
          pauseCycle();
        document.querySelectorAll('.top_button').forEach(btn => {
          btn.style.visibility = 'hidden';
        });
      }
    }
}

  if (slider) { // Desktop only
    let isDragging = false;
    let startX;
    let scrollLeft;
    const dragThreshold = 10; // Minimum pixels to consider a drag

    function getVisibleThumbnails() {
      return Array.from(document.querySelectorAll('.thumbnail-list__item')).filter(item => {
        return window.getComputedStyle(item).display !== 'none';
      });
    }

 function onDragLeft() {
  // console.log('Dragged Left');

  const visibleItems = getVisibleThumbnails();
  const currentIndex = visibleItems.findIndex(item => {
    const btn = item.querySelector('button[aria-current="true"]');
    return btn !== null;
  });

  //  console.log('my current index is ' + currentIndex + ' and my visible items is ' + visibleItems.length);

  let nextBtn;
  if (currentIndex < visibleItems.length - 1) {
    nextBtn = visibleItems[currentIndex + 1].querySelector('button');
  } else {
    nextBtn = visibleItems[currentIndex - 1].querySelector('button');
  }

  // ✅ Clear aria-current from all *visible* thumbnails
  visibleItems.forEach(item => {
    const btn = item.querySelector('button');
    if (btn) btn.removeAttribute('aria-current');
  });

  // ✅ Mark the next one as current
  if (nextBtn) {
    nextBtn.setAttribute('aria-current', 'true');
    nextBtn.click(); // keep your existing logic
  }
  const nextLi = nextBtn.closest('li');
   cycleImage(nextLi.getAttribute('data-target'),nextLi.getAttribute('data-variant-id'));
}

  function onDragRight() {
  // console.log('Dragged Right');

  const visibleItems = getVisibleThumbnails();
  const currentIndex = visibleItems.findIndex(item => {
    const btn = item.querySelector('button[aria-current="true"]');
    return btn !== null;
  });

  // console.log('my current index is ' + currentIndex + ' and my visible items is ' + visibleItems.length);

  // Determine the previous button (wrap around to last if at start)
  let prevBtn;
  if (currentIndex > 0) {
    prevBtn = visibleItems[currentIndex - 1].querySelector('button');
  } else {
    prevBtn = visibleItems[visibleItems.length - 1].querySelector('button');
  }

  // ✅ Clear aria-current from all visible thumbnails
  visibleItems.forEach(item => {
    const btn = item.querySelector('button');
    if (btn) btn.removeAttribute('aria-current');
  });

  // ✅ Mark the previous one as current
  if (prevBtn) {
    prevBtn.setAttribute('aria-current', 'true');
    prevBtn.click(); // Keep your existing behavior
  }
   cycleImage();
}


    slider.addEventListener('mousedown', (e) => {
      isDragging = true;
      slider.classList.add('dragging');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDragging = false;
      slider.classList.remove('dragging');
    });

    slider.addEventListener('mouseup', (e) => {
      if (!isDragging) return;
      isDragging = false;
      slider.classList.remove('dragging');

      const endX = e.pageX - slider.offsetLeft;
      const dx = endX - startX;

      if (dx > dragThreshold) {
        onDragRight(); // User dragged right
      } else if (dx < -dragThreshold) {
        onDragLeft(); // User dragged left
      }
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // multiplier for scroll speed
      slider.scrollLeft = scrollLeft - walk;
    });

  }
if (prevBtns) {
  const prevClickTargets = [prevBtns, ...prevBtns.querySelectorAll('*')];

  prevClickTargets.forEach(el => {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation(); // prevent bubbling and double-firing
      onDragRight();
    });
  });
}

if (nextBtns) {
  const nextClickTargets = [nextBtns, ...nextBtns.querySelectorAll('*')];

  nextClickTargets.forEach(el => {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation(); // prevent bubbling and double-firing
      onDragLeft();
      // console.log('clicked');
    });
  });
}
});